import { render, staticRenderFns } from "./SchoolFacialDeviceTableControl.vue?vue&type=template&id=55a348e3&scoped=true&"
import script from "./SchoolFacialDeviceTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialDeviceTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a348e3",
  null
  
)

export default component.exports